import styled from '@emotion/styled'
import { colors } from '@mathflat/common/style'
import { subDays, subMonths } from 'date-fns'
import React, { useMemo } from 'react'

import { _OldButton } from '@/component/atoms/Button/_OldButton'

import type { DatePickerProps as DatePickerProps } from './DatePicker'
import DatePicker from './DatePicker'

export type Props = {
  dateNavigationButtons?: {
    type: 'PREV_7D_SHORT' | 'PREV_7D' | 'PREV_1M_SHORT' | 'PREV_1M' | 'PREV_2M_SHORT' | 'PREV_2M'
    onClick: (startDate: Date, endDate: Date) => void
  }[]
} & DatePickerProps

const DatePeriodPicker = ({
  date,
  position,
  minDate,
  maxDate,
  setDate,
  pointedDates,
  dateNavigationButtons = [
    {
      type: 'PREV_7D',
      onClick: () => ({
        startDate: subDays(new Date(), 7),
        endDate: new Date(),
      }),
    },
    {
      type: 'PREV_1M',
      onClick: () => ({
        startDate: subMonths(new Date(), 1),
        endDate: new Date(),
      }),
    },
  ],
  onNextMonthClick,
  onPrevMonthClick,
}: Props) => {
  const footer = useMemo(
    () => (
      <S.Footer>
        <div className="button-wrapper">
          {dateNavigationButtons?.map(({ type, onClick }) => {
            const { label, startDate, endDate } = (() => {
              switch (type) {
                case 'PREV_7D_SHORT':
                  return {
                    label: '지난 7일',
                    startDate: subDays(new Date(), 7),
                    endDate: new Date(),
                  }
                case 'PREV_7D':
                  return {
                    label: '오늘 기준 지난 7일',
                    startDate: subDays(new Date(), 7),
                    endDate: new Date(),
                  }
                case 'PREV_1M_SHORT':
                  return {
                    label: '지난 한 달',
                    startDate: subDays(new Date(), 30),
                    endDate: new Date(),
                  }
                case 'PREV_1M':
                  return {
                    label: '오늘 기준 지난 한 달',
                    startDate: subMonths(new Date(), 1),
                    endDate: new Date(),
                  }
                case 'PREV_2M_SHORT':
                  return {
                    label: '지난 두 달',
                    startDate: subDays(new Date(), 60),
                    endDate: new Date(),
                  }
                case 'PREV_2M':
                  return {
                    label: '오늘 기준 지난 두 달',
                    startDate: subMonths(new Date(), 2),
                    endDate: new Date(),
                  }
                default:
                  return { label: '', startDate: new Date(), endDate: new Date() }
              }
            })()
            return (
              <_OldButton
                key={type}
                theme="status-출석"
                height={32}
                onClick={() => {
                  onClick(startDate, endDate)
                  document.body.click()
                }}
              >
                {label}
              </_OldButton>
            )
          })}
        </div>
        <div className="info">최대 1년까지 조회할 수 있습니다.</div>
      </S.Footer>
    ),
    [],
  )
  return (
    <DatePicker
      date={date}
      setDate={(date) => {
        setDate(date)
      }}
      minDate={minDate}
      maxDate={maxDate}
      position={position}
      pointedDates={pointedDates}
      onPrevMonthClick={onNextMonthClick}
      onNextMonthClick={onPrevMonthClick}
      footer={footer}
    />
  )
}

export default DatePeriodPicker

const S = {
  Footer: styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${colors.gray.$400};
    border-top: none;
    background-color: white;
    border-bottom-left-radius: var(--Radius-100);
    border-bottom-right-radius: var(--Radius-100);

    .button-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 16px;
      button {
        width: fit-content;
        padding: 7px 14px;
        white-space: nowrap;
      }
      button + button {
        margin-left: 5px;
      }
    }
    .info {
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${colors.gray.$200};
      height: 33px;

      border-bottom-left-radius: var(--Radius-100);
      border-bottom-right-radius: var(--Radius-100);
    }
  `,
}
